import Error from '.Error';
import test from '.RegExp.prototype.test';
import push from '.Array.prototype.push';
import apply from '.Reflect.apply';
import undefined from '.undefined';

import * as deps from '../deps';
import * as ing from './ing';

export let erase                                                           ;
export const set_erase =                                                                       (value   )    => erase = value;

export const EOL = /\r\n?|[\n\u2028\u2029]/;
export const INDEX_OF_EOL = /[\n\r\u2028\u2029]/;
export const INCLUDES_EOL = /*#__PURE__*/test.bind(INDEX_OF_EOL);
export const WHITESPACES_AND_COMMENT = /\s|\/(?:\/.*|\*[^]*?\*\/)/gy;
export const CHAR_NOT_EOL = /*#__PURE__*/test.bind(/[^\n\r/\u2028\u2029]/);
export const FIRST_MAYBE_SECOND_WHITESPACE = /^[^\n\r/\u2028\u2029]{1,2}/;
export const TAB_INDENT = /^(?:[\n\r\u2028\u2029]\t*)+/;
export const SPACE_INDENT = /^(?:[\n\r\u2028\u2029] *)+/;

export const min = (a        , b        ) => a<b ? a : b;

export const slice = (start        , end         ) => ing.ts.slice(start, end);
export const codeOf = (range                        ) => ing.ts.slice(range.pos, range.end);

export const throwPosError = (index        , message        )        => {
	if ( ing.filename!==undefined ) {
		const linesBeforeError = ing.ts.slice(0, index).split(EOL);
		const errorLineNumber = linesBeforeError.length;
		message += `\n    at (${ing.filename}:${errorLineNumber}:${linesBeforeError[errorLineNumber - 1] .length + 1})`;
	}
	const error                             = Error(message);
	error.index = index;
	throw error;
};

const LEADING_WHITESPACE_OR_COMMENT = /*#__PURE__*/( () => {
	const re = /\s+|\/(?:\/.*|\*[^]*?\*\/)/y;
	re.test = test;
	return re;
} )();
const AT$_$ = /@\S+\s+.*(?:$|[\n\r\u2028\u2029])/g;
export function * readAT                   (            exec                                          )                           {
	let lastIndex = LEADING_WHITESPACE_OR_COMMENT.lastIndex = 0;
	while ( LEADING_WHITESPACE_OR_COMMENT.test(ing.ts) ) {
		if ( ing.ts[lastIndex]==='/' ) {
			const all = ( ing.ts[lastIndex + 1]==='/'
					? ing.ts.slice(lastIndex + 2)
					: ing.ts.slice(lastIndex + 2, LEADING_WHITESPACE_OR_COMMENT.lastIndex - 2)
			).match(AT$_$);
			if ( all ) {
				const valid = ing.ts.startsWith('/**', lastIndex) && ing.ts[lastIndex + 3]!=='*';
				for ( const each of all ) {
					const _$ = exec(each.slice(1));
					if ( _$ ) {
						valid || throwPosError(lastIndex, `a JSDoc comment should start with "/**"`);
						yield _$;
					}
				}
			}
		}
		lastIndex = LEADING_WHITESPACE_OR_COMMENT.lastIndex;
	}
}

const S = /\S/g;
export const eraseCode = (code        ) => code.replace(S, ' ');
export const eraseBetween = (start        , end        ) => ing.ts.slice(start, end).replace(S, ' ');
export const eraseRange = (range                        ) => ing.ts.slice(range.pos, range.end).replace(S, ' ');

const LEADING_WHITESPACES_AND_COMMENT = /^(?:\s+|\/(?:\/.*|\*[^]*?\*\/))+/;
export const trimBefore = (_real        ) => _real.replace(LEADING_WHITESPACES_AND_COMMENT, '');
export const RealPos = ({ pos, end }                        ) => end - trimBefore(ing.ts.slice(pos, end)).length;

const COMMENT = /\/(?:\/.*|\*[^]*?\*\/)/g;
export const IndexAfterD = (beforeColon        ) => beforeColon.replace(COMMENT, eraseCode).lastIndexOf(')') + 1;

export const eraseFirstGT = (_gt$        ) => {
	const gt$ = trimBefore(_gt$);
	return _gt$.slice(0, -gt$.length) + ' ' + gt$.slice(1);
};

                             
	                    
	                    
	                     
	                                          
	                                        
  
                                                        
                                           
                                                                                                           
let childNodes                    = null;
let childNodes_writable = false;
const pushNode = (node      )        => {
	if ( childNodes ) {
		if ( childNodes_writable ) { ( childNodes           )[childNodes.length] = node; }
		else {
			childNodes = [ ...childNodes, node ];
			childNodes_writable = true;
		}
	}
	else {
		childNodes = [ node ];
		childNodes_writable = true;
	}
	return false;
};
const pushNodes = (nodes                 )        => {
	if ( childNodes ) {
		if ( childNodes_writable ) { apply(push, childNodes          , nodes); }
		else {
			childNodes = [ ...childNodes, ...nodes ];
			childNodes_writable = true;
		}
	}
	else { childNodes = nodes; }
	return false;
};
export const ChildNodes = (node      )                    => {
	try {
		deps.forEachChild(node       , pushNode, pushNodes);
		return childNodes;
	}
	finally { childNodes = null; }
};
const CHILDREN = []         ;
export const Children = (node      )           => {
	let ts_index = node.pos;
	const childNodes = ChildNodes(node);
	if ( childNodes ) {
		const children                      = [];
		let children_length = 0;
		for ( const child of childNodes ) {
			if ( ts_index!==child.pos ) { children[children_length++] = ing.ts.slice(ts_index, child.pos); }
			children[children_length++] = child;
			ts_index = child.end;
		}
		if ( ts_index!==node.end ) { children[children_length] = ing.ts.slice(ts_index, node.end); }
		return children;
	}
	return ts_index===node.end ? CHILDREN : [ ing.ts.slice(ts_index, node.end) ];
};

const search = /[A-Z]+/g;
const replacer = (A2Z        ) => A2Z.toLowerCase();
export const A2a = (string        ) => string.replace(search, replacer);
